module.exports = __webpack_public_path__ + "assets/pro-icon.c11c9341.svg";